// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__311qH","field":"styles_field__iML9k","fieldCol":"styles_fieldCol__1dNs8","diffCol":"styles_diffCol__Accxn","diff":"styles_diff__2Y09h"};